import { render, staticRenderFns } from "./profile-dropdown.vue?vue&type=template&id=6bdb7ec2&"
import script from "./profile-dropdown.vue?vue&type=script&lang=ts&"
export * from "./profile-dropdown.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports